import { render, staticRenderFns } from "./ClientDialog.vue?vue&type=template&id=6fdc0148&"
import script from "./ClientDialog.vue?vue&type=script&lang=js&"
export * from "./ClientDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports